// Mint-MarketShare: dữ liệu mẫu + gom nhóm. Sinh đúng script board (TblCustomsData · tên doanh nghiệp minh hoạ, MST ẩn 4 số cuối).

export type Mode = 'SEA' | 'AIR' | 'ROAD' | 'OTH';
export interface Decl { id: number; m: string; sh: string; tx: string; cus: string; cn: string; ic: string; hs: string; cm: string; tm: Mode; tr: string; cu: string; s: number; kg: number; no: string; d: string }

export const MONTHS = ['2025-10', '2025-11', '2025-12', '2026-01', '2026-02', '2026-03', '2026-04', '2026-05', '2026-06', '2026-07', '2026-08', '2026-09'] as const;
export const GAP_MONTH = '2026-02';
const MLB: Record<string, string> = { '01': 'Jan', '02': 'Feb', '03': 'Mar', '04': 'Apr', '05': 'May', '06': 'Jun', '07': 'Jul', '08': 'Aug', '09': 'Sep', '10': 'Oct', '11': 'Nov', '12': 'Dec' };
export const mLabel = (m: string) => `${MLB[m.slice(5)]}/${m.slice(2, 4)}`;
export const HSN: Record<string, string> = { '0304': 'Cá phi lê', '0306': 'Giáp xác đông lạnh', '0303': 'Cá đông lạnh', '0810': 'Quả tươi', '0307': 'Nhuyễn thể', '4412': 'Gỗ dán', '0709': 'Rau tươi', '4415': 'Pallet gỗ', '0811': 'Quả đông lạnh', '4401': 'Dăm gỗ', '0801': 'Dừa, hạt điều' };
export const TM_LABEL: Record<Mode, string> = { SEA: 'Đường biển', AIR: 'Hàng không', ROAD: 'Đường bộ', OTH: 'Khác' };
export const TERM_GROUPS = ['E', 'F', 'C', 'D'] as const;
export const TERM_LABEL: Record<string, string> = { E: 'EXW', F: 'FOB · FCA', C: 'CFR · CIF · CPT', D: 'DAP · DDP' };
export const HS_CHAPTER: Record<string, string> = { '03': 'Thuỷ sản', '08': 'Quả & hạt', '07': 'Rau củ', '44': 'Gỗ' };

type Shp = readonly [string, string, string, readonly string[], readonly string[], Mode, string, string, number, number];
const SHP: readonly Shp[] = [
  ['CTY TNHH THUỶ SẢN AN KHÁNH', '18011•••••', 'KHANGTRI', ['0304', '0303'], ['China', 'Korea (Republic)', 'Japan'], 'SEA', 'CFR', 'HQ CK cảng Sài Gòn KV1', 9, 1.06],
  ['CTY CP NÔNG SẢN ĐỨC HƯNG', '03158•••••', '', ['0810', '0811'], ['China', 'Thailand'], 'SEA', 'FOB', 'HQ CK cảng Sài Gòn KV1', 8, 1.12],
  ['CTY TNHH GỖ VIỆT THÀNH', '37018•••••', '', ['4412', '4415'], ['USA', 'Japan', 'Korea (Republic)'], 'SEA', 'FOB', 'HQ Cái Mép', 6, 0.97],
  ['CTY CP THỰC PHẨM XANH NAM BỘ', '03012•••••', 'GREENBUD', ['0811', '0709'], ['Japan', 'Australia'], 'SEA', 'CIF', 'HQ CK cảng Sài Gòn KV1', 5, 1.04],
  ['CTY TNHH HẢI SẢN BÌNH MINH', '22004•••••', '', ['0306', '0307'], ['USA', 'Canada', 'Japan'], 'SEA', 'CFR', 'HQ CK cảng Sài Gòn KV4', 7, 1.15],
  ['CTY TNHH TRÁI CÂY PHƯƠNG NAM', '18017•••••', '', ['0810'], ['China', 'HongKong'], 'ROAD', 'DAP', 'HQ CK Móng Cái', 6, 0.92],
  ['CTY CP DỪA THẠNH PHÚ', '13008•••••', 'THANHHAO', ['0801'], ['China', 'UAE', 'Malaysia'], 'SEA', 'FOB', 'HQ CK cảng Sài Gòn KV1', 4, 1.02],
  ['CTY TNHH DĂM GỖ MIỀN TRUNG', '41009•••••', '', ['4401'], ['Japan', 'China'], 'SEA', 'FOB', 'HQ cảng Dung Quất', 5, 1.0],
  ['CTY TNHH THUỶ SẢN TÂY ĐÔ', '18009•••••', '', ['0304', '0306'], ['Singapore', 'Malaysia', 'Taiwan'], 'AIR', 'CPT', 'HQ CK sân bay TSN', 3, 1.2],
  ['CTY CP RAU QUẢ CAO NGUYÊN', '58006•••••', '', ['0709', '0810'], ['Singapore', 'Taiwan'], 'AIR', 'FCA', 'HQ CK sân bay TSN', 3, 1.08],
];
const CNE: Record<string, readonly string[]> = { China: ['Guangzhou Oceanic Foods', 'Shenzhen Fresh Mart'], 'Korea (Republic)': ['Busan Fresh Co.', 'Incheon Seafood'], Japan: ['Kanto Foods KK', 'Osaka Trading KK'], USA: ['Pacific Seafood LLC', 'Atlantic Wood Inc.'], Thailand: ['Bangkok Fruit Co.'], Australia: ['Sydney Fresh Pty'], Canada: ['Vancouver Ocean Ltd'], HongKong: ['HK Fruit Link'], UAE: ['Jebel Ali Foods FZE'], Malaysia: ['Lion Home Sdn Bhd'], Singapore: ['Lion Home Pte'], Taiwan: ['Kaohsiung Mart'] };

const hsh = (s: string) => { let h = 7; for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) % 100003; return h; };

function build(): Decl[] {
  const all: Decl[] = [];
  SHP.forEach(([sh, tx, cus, hss, ctrs, tm, tr, cu, base, gr], si) => {
    MONTHS.forEach((m, mi) => {
      if (m === GAP_MONTH) return; // DB không có tháng 2026-02
      ctrs.forEach((ic, ci) => {
        const h = hsh(sh + m + ic);
        if (ci > 0 && h % 3 === 0) return;
        const s = Math.max(1, Math.round((base / (ci + 1)) * Math.pow(gr, mi) * (0.7 + (h % 60) / 100)));
        const hs = hss[(h + mi) % hss.length]!;
        const kgPer = tm === 'AIR' ? 900 : hs.startsWith('44') ? 21000 : 18500;
        const cns = CNE[ic] ?? ['Overseas Buyer'];
        all.push({
          id: all.length, m, sh, tx, cus, cn: cns[h % cns.length]!, ic, hs, cm: HSN[hs]!,
          tm: tm === 'SEA' && h % 11 === 0 ? 'OTH' : tm, tr: h % 7 === 0 ? 'EXW' : tr, cu, s, kg: s * kgPer * (0.8 + (h % 40) / 100),
          no: '30' + String(5800000000 + h * 9137 + mi * 13 + si).slice(0, 10),
          d: `${String(3 + (h % 25)).padStart(2, '0')}/${MLB[m.slice(5)]}/${m.slice(0, 4)}`,
        });
      });
    });
  });
  return all;
}
export const DECLS: readonly Decl[] = build();

export type FilterKey = 'mode' | 'ctry' | 'hs' | 'term' | 'cu' | 'month' | 'sh' | 'cn';
export type Filters = Partial<Record<FilterKey, string>>;
export const termG = (x: string) => (x || 'N/A').charAt(0);
const FVAL: Record<FilterKey, (r: Decl) => string> = { mode: (r) => r.tm, ctry: (r) => r.ic, hs: (r) => r.hs.slice(0, 2), term: (r) => termG(r.tr), cu: (r) => r.cu, month: (r) => r.m, sh: (r) => r.sh, cn: (r) => r.cn };

const norm = (x: string) => x.normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/đ/g, 'd').replace(/Đ/g, 'D').toLowerCase();
export const nf = (n: number) => Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
export const pct1 = (a: number, b: number) => ((a * 100) / (b || 1)).toFixed(1).replace('.', ',') + '%';
export const sumS = (xs: readonly Decl[]) => xs.reduce((a, r) => a + r.s, 0);
export const teu = (xs: readonly Decl[]) => Math.round(xs.reduce((a, r) => a + r.kg, 0) / 14000);

export interface Query { range: number; q: string; flt: Filters }
/** Lọc theo khoảng tháng gần nhất (0 = tất cả), từ khoá và bộ lọc; `skip` bỏ một trường (để biểu đồ theo tháng không tự lọc mình). */
export function select(rows: readonly Decl[], { range, q, flt }: Query, skip?: FilterKey): Decl[] {
  const cut = range ? MONTHS.indexOf('2026-09') - range + 1 : 0;
  const nq = norm(q);
  return rows.filter((r) => {
    if (range && MONTHS.indexOf(r.m as (typeof MONTHS)[number]) < cut) return false;
    if (nq && !norm(`${r.sh} ${r.cn} ${r.tx} ${r.hs} ${r.cm} ${r.ic} ${r.cus}`).includes(nq)) return false;
    return (Object.keys(flt) as FilterKey[]).every((k) => k === skip || !flt[k] || FVAL[k](r) === flt[k]);
  });
}

export function topOf(rows: readonly Decl[], key: 'sh' | 'ic' | 'hs' | 'cn' | 'cu' | 'cm', n: number) {
  const mp = new Map<string, number>();
  rows.forEach((r) => mp.set(r[key], (mp.get(r[key]) ?? 0) + r.s));
  const arr = [...mp].sort((a, b) => b[1] - a[1]).slice(0, n);
  const mx = arr[0]?.[1] ?? 1;
  const tot = sumS(rows) || 1;
  return arr.map(([k, v], i) => ({ i: i + 1, raw: k, v, pct: pct1(v, tot), w: Math.round((v / mx) * 100) }));
}

export function groupBy(rows: readonly Decl[], key: 'sh' | 'cn'): Map<string, Decl[]> {
  const mp = new Map<string, Decl[]>();
  rows.forEach((r) => { const a = mp.get(r[key]); if (a) a.push(r); else mp.set(r[key], [r]); });
  return mp;
}

/** Shipper tăng mạnh: 3 tháng gần nhất so với 3 tháng liền trước (dock 372). */
export function risers(rows: readonly Decl[], n = 5) {
  return [...groupBy(rows, 'sh')].map(([k, xs]) => {
    const a = sumS(xs.filter((r) => MONTHS.indexOf(r.m as (typeof MONTHS)[number]) >= 9));
    const b = sumS(xs.filter((r) => { const i = MONTHS.indexOf(r.m as (typeof MONTHS)[number]); return i >= 6 && i < 9; })) || 1;
    return { k, v: (a - b) / b, d: `${a >= b ? '+' : '−'}${Math.abs(Math.round(((a - b) * 100) / b))}%` };
  }).sort((a, b) => b.v - a.v).slice(0, n);
}
